import { PartialThemeIds } from '@porter/shared-theme';
import API_URL from '../apiconfig';
import axios from './api';

export interface BookingSiteThemeResult extends PartialThemeIds {
  /** False when the shop has never customized. */
  customized: boolean;
  instagramHandle: string | null;
  tiktokHandle: string | null;
  facebookUrl: string | null;
  websiteUrl: string | null;
}

export async function getBookingSiteTheme(params: {
  shop?: string;
  artist?: string;
  businessId?: string;
}) {
  const response = await axios.get<{ result: BookingSiteThemeResult }>(
    `${API_URL}/v1/booking-site/theme`,
    // The page is held blank until this resolves, so it needs a tighter bound
    // than the 30s default. A timeout reads as an error and renders unthemed.
    { params, timeout: 3000 },
  );

  return response.data.result;
}
